import { innerGet as get, innerPost as post, initConfig, fetchOrigin } from '@binanceus/http';
import getConfig from 'next/config';
import { pushLoginPage } from '../../utils/urlUtils';

const { fetch } = fetchOrigin();
const { apiHostname } = getConfig().serverRuntimeConfig || {};

const isServer = typeof window === 'undefined';

if (isServer) {
  initConfig({
    baseUrl: apiHostname,
    //baseUrl: 'http://internal-tk-qa-us-binance-gateway-alb-1408233396.ap-northeast-1.elb.amazonaws.com:9015',
  });
} else {
  initConfig({
    responseInterceptor: (res) => {
      if (res.status === 401) {
        pushLoginPage();
      }
      return res;
    },
  });
}

// Get request for gateway
export const gwGet = async (apiPath, options = {},) => {
  try {
    const res = await get(
      apiPath,
      options,
    );
    return res;
  } catch (err) {
    console.error(`gwGet url: ${apiPath} request fail, the error message is: `, err)
    return {};
  }
}

// Post request for gateway
export const gwPost = async (apiPath, data = {}, options = {}) => {
  try {
    const res = await post(
      apiPath,
      data,
      options,
    );
    return res;
  } catch (err) {
    console.error(`gwPost url: ${apiPath} request fail, the error message is: `, err)
    return {};
  }
}

export const getResources = async url => {
  try {
    const res = await fetch(url, {
      method: 'GET',
      mod: 'cors',
      headers: { Referer: 'https://www.binance.us/' },
    });
    if (res.ok) {
      return res.json();
    }
  } catch (err) {
    console.error(`getResources url:${url} resource fail, the error message is: `, err)
    return {};
  }
};